import type { Location } from 'react-router-dom';

/** Router state carried into `/settings` so its Back returns to the referring view. */
export interface SettingsLocationState {
  returnTo?: string;
}

export const settingsLinkState = (
  location: Location,
): SettingsLocationState => ({
  returnTo: `${location.pathname}${location.search}`,
});

export const getSettingsReturnTo = (state: unknown, fallback = '/'): string => {
  if (state && typeof state === 'object' && 'returnTo' in state) {
    const { returnTo } = state as SettingsLocationState;
    if (
      typeof returnTo === 'string' &&
      returnTo.startsWith('/') &&
      !returnTo.startsWith('//') &&
      !returnTo.startsWith('/settings')
    ) {
      return returnTo;
    }
  }
  return fallback;
};
